<div class="reflow-menu">
    <ul class="nav navbar-nav">
        <li class="active" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
            <img src="{{ currentUser?.profilePicture }}" alt="" />
            <label class="sidebar-username" id="user">Hi {{ currentUser?.fullName }}</label>
            <em class="fa fa-angle-down expend-icon" id="expend"></em>
        </li>
        <li class="collapse" id="collapseExample" (click)="showImageModal(true)">
            <em class="fa fa-picture-o"></em>
            <label>Change profile image</label>
        </li>
        <li class="collapse" id="collapseExample" (click)="logOut()">
            <em class="fa fa-sign-out"></em>
            <label>Log out</label>
        </li>
    </ul>

    <ul class="nav navbar-nav flexed separated">
        <li class="menu-title">Old Backoffice</li>
        <li routerLink="dashboard">
            <em class="icon-project" style="font-size: 18px;"></em>
            <label>Dashboard</label>
        </li>
        <li routerLink="external-companies">
            <em class="icon-ex-company"></em>
            <label>External companies</label>
        </li>
        <li routerLink="mastersheet/databases">
            <em class="icon-file-earmark-spreadsheet"></em>
            <label>Edit MasterSheet</label>
        </li>
        <li routerLink="admin-academy">
            <em class="icon-new_academy"></em>
            <label>Reflow Academy</label>
        </li>
        <li routerLink="Validation-dashboard">
            <em class="icon-certificate" style="font-size: 22px;"></em>
            <label>Validation dashboard</label>
        </li>
        <li routerLink="quima-usage">
            <em class="icon-certificate" style="font-size: 22px;"></em>
            <label>Quima Usage</label>
        </li>
    </ul>

    <ul class="nav navbar-nav flexed separated">
        <li class="menu-title">New Backoffice</li>
        <li routerLink="/homeAdmin/v2/companies">
            <em class="icon-company"></em>
            <label>Companies</label>
        </li>
        <li routerLink="/homeAdmin/v2/users">
            <em class="icon-company"></em>
            <label>Users</label>
        </li>
        <li routerLink="/homeAdmin/v2/scenarioCategory">
            <em class="icon-new_academy active-menu"></em>
            <label class="active-label">Scenario Category</label>
        </li>
        <li routerLink="/homeAdmin/v2/fuelOptions">
            <em class="icon-ship active-menu"></em> 
            <label class="active-label">Fuel Option</label>
        </li>
        <li routerLink="/homeAdmin/v2/recyclingOptions">
            <em class="icon-ship active-menu"></em> 
            <label class="active-label">Recycling Option</label>
        </li>
        <li routerLink="/homeAdmin/v2/steelSourceOptions">
            <em class="icon-ship active-menu"></em> 
            <label class="active-label">Steel Source Option</label>
        </li>
        <li routerLink="/homeAdmin/v2/energyOptions">
            <em class="icon-ship active-menu"></em>
            <label class="active-label">Energy Option</label>
        </li>
                <li routerLink="/homeAdmin/v2/vesselSubgroup">
            <em class="icon-ship active-menu"></em>
            <label class="active-label">Vessel Subgroup</label>
        </li>
    </ul>

    <ul class="nav navbar-nav flexed separated">
        <li routerLink="/quantify">
            <em class="fa fa-arrow-left"></em>
            <label>Go to ClimateHub</label>
        </li>
    </ul>
</div>
